// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"555":"9f918938","837":"a28e031b"}[chunkId] + ".chunk.js";
};